<template>
  <div ref="balloon__container" class="balloon__container">
    <div
      v-for="(b, i) in data"
      :key="`${scenario}-${b.year}`"
      class="balloon-content"
      :style="{
        left: `${
          (cwidth / 8) * (2 * index + 1) -
          (((maxSizeToScreen * b.value) / max) * widthRatio) / 2
        }px`,
      }"
    >
      <div
        class="balloon"
        :class="[
          `background-${color}`,
          `after-${color}`,
          `before-${color}`,
          `balloon-${index}`,
          `balloon-${index}-${i}`,
          { popped: index === 0 && i === 3 },
        ]"
        :style="{
          width: `${((maxSizeToScreen * b.value) / max) * widthRatio}px`,
          height: `${(maxSizeToScreen * b.value) / max}px`,
        }"
      >
        <div
          v-if="showLabel && b.show"
          :class="[`label-${index}-${i}`]"
          class="labels"
        >
          <p v-if="index === 0 && i === 0" class="f-ui-2-bold">Emissions</p>
          <p v-if="b.nze" class="f-ui-2-bold">Net Zero 2050</p>
          <p v-if="!b.nze">
            {{ b.value }}<span v-if="index === 0 && i === 0"> GtCO2</span>
          </p>
        </div>
        <div
          v-if="showLabel && index === 1"
          :class="[`label-${index}-${i}`]"
          class="labels"
        >
          <p class="f-ui-2-bold" :class="[`label-years-${i}`]">{{ b.year }}</p>
        </div>
      </div>
    </div>
    <div style="height: 100%; width: 100%">
      <div
        class="string"
        :class="`string-${index}`"
        :style="{
          bottom: `${siblingHeight}px`,
          left: `${(cwidth / 8) * (2 * index + 1)}px`,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  props: {
    color: {
      type: String,
      default: "red",
    },
    data: {
      type: Array,
    },
    gondola: {
      type: Number,
    },
    scenario: {
      type: String,
    },
    max: {
      type: Number,
    },
    index: {
      type: Number,
    },
    maxSize: {
      type: Number,
    },
  },
  data() {
    return {
      cwidth: 0,
      cheight: 0,
      widthRatio: 0.85,
      defaultAngle: -20,
      defaultOffset: [-20, -20, -30, -20],
      siblingHeight: 0,
      siblingMargin: 15,
      gondolaSize: 20,
      showLabel: false,
    };
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    const { index, defaultAngle, gondola, defaultOffset, shiftY } = this;
    this.siblingHeight =
      this.$parent.$parent.$children[1].$el.offsetHeight + this.siblingMargin;
    let container = this.$refs.balloon__container;
    this.cwidth = container.clientWidth;
    this.cheight = container.clientHeight;
    console.log(this.cheight);
    const balloons = gsap.utils.toArray(`.balloon-${index}`);
    const strings = gsap.utils.toArray(`.string-${index}`);

    function normal(val, max, min) {
      return (val - min) / (max - min);
    }
    let pos = [
      [60, 40, 60, 0],
      [30, 10, 10, 30],
      [30, 10, 10, 30],
      [30, 10, 10, 30],
    ];
    strings.forEach((string) => {
      let startYpos = this.cheight - 200;
      let ceiling = this.cheight * 0.2;
      let gondolaIndex = normal(gondola, 3.5, 1.4);
      let groupYEndPos = ceiling - this.cheight * 0.2 * gondolaIndex;
      let endYpos =
        index === 2 || index === 3
          ? startYpos * 0.2
          : index === 0
          ? groupYEndPos * 1.2
          : groupYEndPos;
      let height = startYpos - endYpos;

      gsap.set(string, {
        height: "0px",
      });
      gsap.to(string, {
        transform: `translateY(${this.shiftY}px)`,
        height: `${height}px`,
        // height: `50px`,
        duration: 2,
        delay: 0.25,
      });
    });

    balloons.forEach((balloon, i) => {
      let gondolaIndex = normal(gondola, 3.5, 1.4);
      let ceiling = this.cheight * 0.2;

      let startXpos = `translateX(${
        i * -defaultOffset[index] + defaultOffset[index]
      }px)`;
      let startYpos = this.cheight - 200;
      let groupYEndPos = ceiling - this.cheight * 0.2 * gondolaIndex;
      let endYpos =
        index === 0 && i === 3
          ? this.cheight - this.siblingHeight
          : pos[index][i] + groupYEndPos;
      gsap.set(balloon, {
        transform: `${startXpos} translateY(${startYpos}px) scale(0.1) rotate(${
          i * 10 + defaultAngle
        }deg)`,
      });
      gsap.to(balloon, {
        transform: `${startXpos} translateY(${endYpos}px) scale(1) rotate(${
          i * 10 + defaultAngle
        }deg) `,
        duration: 2,
        delay: 0.25,
        onComplete: () => (this.showLabel = true),
      });
    });
  },
  methods: {
    resize() {
      let container = this.$refs.balloon__container;
      this.cwidth = container.clientWidth;
      this.cheight = container.clientHeight;
      this.siblingHeight =
        this.$parent.$parent.$children[1].$el.offsetHeight + this.siblingMargin;
    },
  },
  computed: {
    maxSizeToScreen() {
      return this.cwidth * this.maxSize;
    },
    shiftY() {
      const { cheight, gondola, gondolaSize } = this;
      let max = (cheight - this.siblingHeight) * 0.3;
      let row = max / 5;
      let offset = (gondolaSize * 0.75) / 2;
      return -(row * (gondola + 1) - offset);
    },
  },
};
</script>

<style scoped>
.balloon__container {
  width: 100%;
  height: 100%;
  position: absolute;
}
.balloon-content {
  position: absolute;
  z-index: 100;
}
.string {
  position: absolute;
  bottom: 82px;
  width: 1px;
  background: #e6e6e6;
  transform-origin: top;
}
.balloon {
  position: absolute;
  opacity: 50%;
  border-radius: 50%;
}
.popped::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  opacity: 80%;
  bottom: -5px;
  width: 20px;
  height: 20px;
  clip-path: polygon(40% 0%, 60% 0%, 20% 100%, 0% 100%);
}
.popped::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  opacity: 80%;
  bottom: -5px;
  width: 10px;
  height: 10px;
  clip-path: polygon(20% 0%, 70% 0%, 50% 100%, 0% 50%);
}

.balloon-0-0 {
  border: 1px solid #646464;
}
.balloon-1-3 {
  border: 1px solid #646464;
}
.balloon-2-3 {
  border: 1px solid #646464;
}
.balloon-3-3 {
  border: 1px solid #646464;
}
.labels {
  font-size: 0.85rem;
  z-index: 1000;
}
.label-0-0 {
  transform: rotate(20deg) translateY(-25px) translateX(-25px);
  position: absolute;
}
.label-1-3 {
  transform: rotate(-10deg) translateY(-5px) translateX(25px);
  position: absolute;
}
.label-2-3 {
  transform: rotate(-10deg) translateY(-5px) translateX(60px);
  position: absolute;
}
.label-3-3 {
  transform: rotate(-10deg) translateY(-15px) translateX(25px);
  position: absolute;
}
.label-0-3 {
  transform: rotate(-10deg);
  width: 100px;
  bottom: 20px;
  position: absolute;
}
.label-years-0 {
  transform: rotate(20deg) translateY(-5px) translateX(-10px);
}
.label-years-1 {
  transform: rotate(10deg) translateY(-10px) translateX(-15px);
}
.label-years-2 {
  transform: translateY(-15px) translateX(5px);
}
.label-years-3 {
  transform: translateY(-20px) translateX(0px);
}
</style>
